import React from 'react';
import { FunctionFactory } from 'survey-core';
import { Trans } from 'react-i18next';
import { Goals } from './goals';
import { loc, locWrap } from '../i18n/survey';

const emailQuestion = {
  name: "email",
  title: loc("quiz.email.title"),
  type: "text",
  // description: `<div class="disclaimer">
  // <div>We'll email you a copy of your results for convenient access.</div><br />
  // By clicking "See My Results" below you acknowledge that you have read, understood, and accepted the <span class="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank">Terms of Use</a></span> and <span class="dislaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank">Privacy Policy</a></span>.  You may receive emails from Built With Science and can unsubscribe at any time.
  // </div>`,
  description: loc("quiz.email.description"),
  inputType: "email",
  isRequired: true,
  placeholder: loc("quiz.email.placeholder"),
  autocomplete: "email",
};

const emailWeightGoalTextExpression = {
  name: "emailWeightGoalText",
  expression: "renderEmailWeightGoalTextExpression({weightGoal}, {goalBodyFat}, {muscleGain}, {goals})",
};

function renderEmailWeightGoalTextExpression(params: any[]): string {
  if (params === undefined || params === null) return "";
  // const weightRaw = params[0] as number;
  // const goalBodyFat = params[1] as BodyFat;
  // const muscleGain = params[2] as number;
  const goals = params[3] as Goals;

  switch (goals) {
    case Goals.LoseFat:
      return `weight loss`;
    case Goals.BuildMuscle:
      return `muscle gain`;
    case Goals.BuildMuscleAndLoseFat:
      return `fat loss`
  }
}

FunctionFactory.Instance.register("renderEmailWeightGoalTextExpression", renderEmailWeightGoalTextExpression);

const emailCopyElement = {
  name: 'email-copy',
  type: 'html',
  title: "asdfsdaf",
  html: locWrap(
    "quiz.email.copy",
    (s) => `<div class="sd-element--with-frame" style="font-size: 12px; font-style: italic; color: #7A7A7A; text-align: center;">${s}</div>`
  ),
}

const emailDisclaimerElement = {
  name: 'email-copy',
  type: 'html',
  title: "asdfsdaf",
  html: `
    <div class="sd-element--with-frame" style="font-size: 12px; font-style: italic; color: #7A7A7A; margin-top: 50px; text-align: center;">
      By clicking “See My Results” below, you acknowledge that you have read, understood, and accepted the <span class="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank">Terms of Use</a></span> and <span class="disclaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank">Privacy Policy</a></span>. You may receive emails from Built With Science and can unsubscribe at any time.
    </div>
  `,
}

const TermsOfUseLink: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span className="disclaimer__terms"><a href="https://builtwithscience.com/terms-of-use/" target="_blank" rel="noreferrer">{children}</a></span>
);

const PrivacyPolicyLink: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span className="disclaimer__terms"><a href="https://builtwithscience.com/privacy-policy/" target="_blank" rel="noreferrer">{children}</a></span>
);

// A component (not a prebuilt element) so the text follows the active language.
const EmailDisclaimer: React.FC = () => (
  <div style={{ marginBottom: "8px" }}>
    <Trans i18nKey="quiz.email.disclaimer" components={{ 1: <TermsOfUseLink />, 2: <PrivacyPolicyLink /> }} />
  </div>
);

const disclaimerElement = <EmailDisclaimer />;

export {
  emailQuestion,
  emailCopyElement,
  emailDisclaimerElement,
  disclaimerElement,
  emailWeightGoalTextExpression,
};
